module.exports = __webpack_public_path__ + "img/image_1.8b7878bb.jpg";